import React from 'react';
import {AppDownloadBanner} from './AppDownloadBanner';
import {SERP} from '../notification-config';
export const AppDownloadBannerWrapper = ({notification, page}) => {
    const imgUrl = notification.logo.url;
    const title = notification.title.items[0].text;
    const description = notification.body[0].items[0].text;
    const link = notification.containerLink.uri.value;
    const useCanonicalPath =
        page && page.toLowerCase() === SERP.toLowerCase() ? true : false;
    return (
        <AppDownloadBanner
            imgUrl={imgUrl}
            title={title}
            description={description}
            ctaLink={link}
            useCanonicalPath={useCanonicalPath}
        />
    );
};
